<template>
  <van-row type="flex" justify="space-between" class="content">
    <van-col span="8" class="content-left">
      {{contentLeft}}
    </van-col>
    <van-col span="16" class="content-right">
      {{contentRight}}
    </van-col>
  </van-row>
</template>
<script>
  /* eslint-disable */
export default {
  props:{
    contentLeft:{
      type:String,
      default:''
    },
    contentRight:{
      type: String | Number,
      default:''
    }
  }
}
</script>
<style lang="less" scoped>
.content{
  padding: 10px 0;
}
.content-left{
  color: #999;
}
.content-right{
  overflow: hidden;
  word-wrap:break-word;
  text-align: right;
  color: #333;
}
</style>